import { Component, OnInit, OnDestroy, Renderer } from '@angular/core';
import { InformacionService } from '../../services/informacion.service';

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html'
})
export class NosotrosComponent implements OnInit, OnDestroy {
  constructor(public _is: InformacionService, private renderer: Renderer) {
    this.renderer.setElementClass(document.body, 'paginas-internas', true);
  }

  ngOnDestroy() {
    this.renderer.setElementClass(document.body, 'paginas-internas', false);
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/nosotros/nosotros.component.ts